import { MEDICAL_FILE_CATEGORY } from '@shafa/shared';
import { formatDate } from '../../../utils/common-funtions/common';

export function refId(ref) {
    if (ref == null) return '';
    if (typeof ref === 'object' && ref._id != null) return String(ref._id);
    return String(ref);
}

/** YYYY-MM-DD for grouping; prefers upload time, falls back to report date */
export function dateKeyFromFile(f) {
    const raw = f.createdAt || f.reportDate;
    if (!raw) return 'unknown';
    const d = new Date(raw);
    if (Number.isNaN(d.getTime())) return 'unknown';
    return d.toISOString().slice(0, 10);
}

export function categoryLabel(value) {
    const entry = Object.entries(MEDICAL_FILE_CATEGORY).find(([, v]) => v === value);
    return entry ? entry[0].replace(/_/g, ' ') : value;
}

export function scopeFilesByVisit(medicalFiles, visitId) {
    if (!visitId) return medicalFiles;
    return medicalFiles.filter((f) => String(f.visitId || '') === String(visitId));
}

export function groupFilesByDate(scopedFiles) {
    const map = new Map();
    for (const f of scopedFiles) {
        const key = dateKeyFromFile(f);
        if (!map.has(key)) map.set(key, []);
        map.get(key).push(f);
    }
    const entries = Array.from(map.entries());
    entries.sort((a, b) => {
        if (a[0] === 'unknown') return 1;
        if (b[0] === 'unknown') return -1;
        return b[0].localeCompare(a[0]);
    });
    return entries;
}

export function formatSectionDateKey(key) {
    if (key === 'unknown') return 'Unknown date';
    return formatDate(`${key}T12:00:00.000Z`);
}
